// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Tiptap = require("../../bindings/Tiptap.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var ReactRender = require("../../../reason/utils/ReactRender.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var LinkSanitizer = require("../../../reason/utils/LinkSanitizer.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var TailwindMerge = require("tailwind-merge");
var Form__HelpLabel = require("../../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var React$1 = require("@floating-ui/react");
var RichTextEditorV5Icons = require("./RichTextEditorV5Icons.bs.js");

var make = React.forwardRef(function (props, ref) {
      var title = props.title;
      var state = props.state;
      var tmp;
      switch (state) {
        case "Active" :
            tmp = "text-sky-600";
            break;
        case "Inactive" :
            tmp = "text-gray-800";
            break;
        case "Disabled" :
            tmp = "text-gray-400 hover:bg-transparent";
            break;
        
      }
      return JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("span", {
                          children: title,
                          className: "sr-only"
                        }),
                    props.children
                  ],
                  ref: Core__Option.map((ref == null) ? undefined : Caml_option.some(ref), (function (prim) {
                          return prim;
                        })),
                  className: TailwindMerge.twMerge([
                        "relative flex items-center bg-white px-3 py-2 font-semibold  hover:bg-gray-50",
                        tmp,
                        Core__Option.getOr(props.className, "")
                      ]),
                  title: title,
                  disabled: state === "Disabled",
                  type: "button",
                  onClick: props.onClick,
                  onMouseDown: props.onMouseDown
                });
    });

var IconButton = {
  make: make
};

function RichTextEditorV5$Toolbar$ItalicsButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.Italics.make, {
                    className: "w-5 h-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleItalic(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "italic") ? "Active" : "Inactive",
              title: "Italic",
              className: props.className
            });
}

var ItalicsButton = {
  make: RichTextEditorV5$Toolbar$ItalicsButton
};

function RichTextEditorV5$Toolbar$BoldButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.Bold.make, {
                    className: "w-5 h-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleBold(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "bold") ? "Active" : "Inactive",
              title: "Bold"
            });
}

var BoldButton = {
  make: RichTextEditorV5$Toolbar$BoldButton
};

function RichTextEditorV5$Toolbar$UnderlineButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.Underline.make, {
                    className: "w-5 h-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleUnderline(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "underline") ? "Active" : "Inactive",
              title: "Underline"
            });
}

var UnderlineButton = {
  make: RichTextEditorV5$Toolbar$UnderlineButton
};

function RichTextEditorV5$Toolbar$BulletListButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.BulletList.make, {
                    className: "w-5 h-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleBulletList(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "bulletList") ? "Active" : "Inactive",
              title: "Bullet list"
            });
}

var BulletListButton = {
  make: RichTextEditorV5$Toolbar$BulletListButton
};

function RichTextEditorV5$Toolbar$OrderedListButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.OrderedList.make, {
                    className: "w-5 h-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleOrderedList(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "orderedList") ? "Active" : "Inactive",
              title: "Ordered list"
            });
}

var OrderedListButton = {
  make: RichTextEditorV5$Toolbar$OrderedListButton
};

function RichTextEditorV5$Toolbar$LinkTool(props) {
  var editor = props.editor;
  var match = React.useState(function () {
        return false;
      });
  var setOpen = match[1];
  var open_ = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setUrl = match$1[1];
  var url = match$1[0];
  var inputRef = React.useRef(null);
  var match$2 = React$1.useFloating({
        open: open_,
        onOpenChange: (function (v) {
            setOpen(function (param) {
                  return v;
                });
          }),
        placement: "bottom-start",
        strategy: "fixed",
        middleware: [
          React$1.offset(8),
          React$1.flip({
                padding: 8
              }),
          React$1.shift({
                padding: 8,
                crossAxis: true
              })
        ]
      });
  var update = match$2.update;
  var context = match$2.context;
  var refs = match$2.refs;
  React.useEffect((function () {
          if (open_) {
            update();
          }
          
        }), [
        open_,
        update
      ]);
  React.useEffect((function () {
          if (open_) {
            requestAnimationFrame(function () {
                  var domElement = inputRef.current;
                  if (domElement === null || domElement === undefined) {
                    return ;
                  }
                  domElement.focus({
                        preventScroll: true
                      });
                });
          }
          
        }), [open_]);
  var match$3 = React$1.useInteractions([
        React$1.useDismiss(context, {
              outsidePress: true,
              escapeKey: true
            }),
        React$1.useRole(context, {
              role: "dialog"
            })
      ]);
  var applyLink = function () {
    var href = LinkSanitizer.makeLinksAbsolute(url.trim());
    if (href === "") {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.unsetLink(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
    } else {
      Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.setLink(Tiptap.Commands.Chainable.extendMarkRange(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), "link"), {
                href: href,
                target: "_blank"
              }));
    }
    setOpen(function (param) {
          return false;
        });
  };
  var tmp;
  if (open_) {
    var newrecord = Caml_obj.obj_dup(match$3.getFloatingProps());
    tmp = JsxRuntime.jsx(React$1.FloatingPortal, {
          children: JsxRuntime.jsx(React$1.FloatingFocusManager, {
                context: context,
                modal: false,
                returnFocus: true,
                children: JsxRuntime.jsx("div", (newrecord.style = match$2.floatingStyles, newrecord.className = "z-[9999] w-max max-w-[400px] rounded-xl border bg-white p-3 shadow-xl", newrecord.ref = Caml_option.some(refs.setFloating), newrecord.children = JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsx(Form__Input.make, {
                                    labelText: "URL",
                                    placeholderText: "https://example.com",
                                    onChange: (function (e) {
                                        var value = e.target.value;
                                        setUrl(function (param) {
                                              return value;
                                            });
                                      }),
                                    onKeyDown: (function (e) {
                                        if (e.key === "Enter") {
                                          e.preventDefault();
                                          return applyLink();
                                        }
                                        
                                      }),
                                    inputMode: "url",
                                    inputRef: Caml_option.some(inputRef)
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                            onClick: (function (param) {
                                                setOpen(function (param) {
                                                      return false;
                                                    });
                                              }),
                                            size: "small",
                                            _type: "button",
                                            children: "Cancel"
                                          }),
                                      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                            onClick: (function (param) {
                                                setOpen(function (param) {
                                                      return false;
                                                    });
                                              }),
                                            size: "small",
                                            _type: "submit",
                                            children: "Apply"
                                          })
                                    ],
                                    className: "flex justify-end gap-2"
                                  })
                            ],
                            className: "flex flex-col gap-2",
                            onSubmit: (function (e) {
                                e.preventDefault();
                                applyLink();
                              })
                          }), newrecord))
              })
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(make, {
                      children: JsxRuntime.jsx(RichTextEditorV5Icons.Link.make, {
                            className: "w-5 h-5"
                          }),
                      onMouseDown: (function (e) {
                          e.preventDefault();
                          var state = Tiptap.Editor.state(editor);
                          if (state.selection.empty) {
                            return ;
                          }
                          var attrs = Tiptap.Editor.getLinkAttributes(editor);
                          setUrl(function (param) {
                                if (attrs === undefined) {
                                  return "";
                                }
                                var href = attrs.href;
                                if (href !== undefined) {
                                  return href;
                                } else {
                                  return "";
                                }
                              });
                          setOpen(function (param) {
                                return true;
                              });
                        }),
                      state: Tiptap.Editor.isActive(editor, "link") ? "Active" : "Inactive",
                      title: "Link",
                      ref: refs.setReference
                    }),
                tmp
              ]
            });
}

var LinkTool = {
  make: RichTextEditorV5$Toolbar$LinkTool
};

function RichTextEditorV5$Toolbar$ClearLinkButton(props) {
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.BreakLink.make, {
                    className: "h-5 w-5"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.unsetLink(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor))));
                }),
              state: Tiptap.Editor.isActive(editor, "link") ? "Inactive" : "Disabled",
              title: "Unset link"
            });
}

var ClearLinkButton = {
  make: RichTextEditorV5$Toolbar$ClearLinkButton
};

function RichTextEditorV5$Toolbar$HeadingButton(props) {
  var level = props.level;
  var editor = props.editor;
  return JsxRuntime.jsx(make, {
              children: JsxRuntime.jsx(RichTextEditorV5Icons.Heading.make, {
                    className: "w-4 h-4"
                  }),
              onClick: (function (param) {
                  Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleHeading(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), {
                            level: level
                          }));
                }),
              state: Tiptap.Editor.isHeadingActive(editor, {
                    level: level
                  }) ? "Active" : "Inactive",
              title: "Heading",
              className: props.className
            });
}

var HeadingButton = {
  make: RichTextEditorV5$Toolbar$HeadingButton
};

function getOptionLabel(option) {
  if (option === "h2") {
    return "Heading 2";
  } else if (option === "h3") {
    return "Heading 3";
  } else if (option === "normal") {
    return "Normal";
  } else {
    return "Heading 1";
  }
}

function getOptionValue(x) {
  return x;
}

var HeadingOption = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function RichTextEditorV5$Toolbar$HeadingDropdown(props) {
  var editor = props.editor;
  var currentLevel = Tiptap.Editor.isHeadingActive(editor, {
        level: 1
      }) ? 1 : (
      Tiptap.Editor.isHeadingActive(editor, {
            level: 2
          }) ? 2 : (
          Tiptap.Editor.isHeadingActive(editor, {
                level: 3
              }) ? 3 : undefined
        )
    );
  var tmp;
  if (currentLevel !== undefined) {
    switch (currentLevel) {
      case 1 :
          tmp = "h1";
          break;
      case 2 :
          tmp = "h2";
          break;
      case 3 :
          tmp = "h3";
          break;
      default:
        tmp = "normal";
    }
  } else {
    tmp = "normal";
  }
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
              getOptionLabel: getOptionLabel,
              getOptionValue: getOptionValue,
              onChange: (function (v) {
                  Core__Option.forEach(Core__Option.flatMap(v, (function (x) {
                              if (x === "h2") {
                                return 2;
                              } else if (x === "h3") {
                                return 3;
                              } else if (x === "normal") {
                                return currentLevel;
                              } else {
                                return 1;
                              }
                            })), (function (x) {
                          Tiptap.Commands.Chainable.run(Tiptap.Commands.Chainable.toggleHeading(Tiptap.Commands.Chainable.focus(Tiptap.Editor.chain(editor)), {
                                    level: x
                                  }));
                        }));
                }),
              options: [
                "h1",
                "h2",
                "h3",
                "normal"
              ],
              value: tmp,
              classNames: {
                menu: (function (param) {
                    return "!rounded-b !border !border-zinc-200 !shadow-sm";
                  }),
                control: (function (param) {
                    return "!border-none !border-0 !rounded-md";
                  }),
                dropdownIndicator: (function (param) {
                    return "!pl-0";
                  }),
                indicatorSeparator: (function (param) {
                    return "hidden";
                  })
              }
            });
}

var HeadingDropdown = {
  HeadingOption: HeadingOption,
  make: RichTextEditorV5$Toolbar$HeadingDropdown
};

function RichTextEditorV5$Toolbar(props) {
  var variant = props.variant;
  var editor = props.editor;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              variant === "default" ? JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(RichTextEditorV5$Toolbar$HeadingDropdown, {
                                            editor: editor
                                          })
                                    }) : (
                                  variant === "withoutHeaders" ? null : JsxRuntime.jsx(RichTextEditorV5$Toolbar$HeadingButton, {
                                          editor: editor,
                                          level: 3,
                                          className: "rounded-tl"
                                        })
                                ),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$ItalicsButton, {
                                    editor: editor,
                                    className: variant === "withoutHeaders" ? "rounded-tl" : undefined
                                  }),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$BoldButton, {
                                    editor: editor
                                  }),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$UnderlineButton, {
                                    editor: editor
                                  })
                            ],
                            className: "divide-x flex"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$BulletListButton, {
                                    editor: editor
                                  }),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$OrderedListButton, {
                                    editor: editor
                                  }),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$LinkTool, {
                                    editor: editor
                                  }),
                              JsxRuntime.jsx(RichTextEditorV5$Toolbar$ClearLinkButton, {
                                    editor: editor
                                  })
                            ],
                            className: "divide-x flex"
                          })
                    ],
                    className: "rounded-md divide-y flex flex-col sm:flex-row sm:divide-x sm:divide-y-0"
                  }),
              className: "w-full border-b z-[2] relative"
            });
}

var Toolbar = {
  IconButton: IconButton,
  ItalicsButton: ItalicsButton,
  BoldButton: BoldButton,
  UnderlineButton: UnderlineButton,
  BulletListButton: BulletListButton,
  OrderedListButton: OrderedListButton,
  LinkTool: LinkTool,
  ClearLinkButton: ClearLinkButton,
  HeadingButton: HeadingButton,
  HeadingDropdown: HeadingDropdown,
  make: RichTextEditorV5$Toolbar
};

function getContent(editor) {
  var state = Tiptap.Editor.state(editor);
  if (state.doc.textContent.trim().length === 0) {
    return ;
  } else {
    return Tiptap.Editor.getHTML(editor);
  }
}

function RichTextEditorV5(props) {
  var __proseStyle = props.proseStyle;
  var editorRef = props.editorRef;
  var id = props.id;
  var optionalText = props.optionalText;
  var status = props.status;
  var __height = props.height;
  var __toolbar = props.toolbar;
  var onChangeFull = props.onChangeFull;
  var onChange = props.onChange;
  var toolbar = __toolbar !== undefined ? __toolbar : "default";
  var height = __height !== undefined ? __height : "long";
  var proseStyle = __proseStyle !== undefined ? __proseStyle : "sm";
  var onUpdate = React.useCallback((function (param) {
          if (!param.transaction.docChanged) {
            return ;
          }
          var editor = param.editor;
          Core__Option.forEach(onChange, (function (fn) {
                  fn(getContent(editor));
                }));
          Core__Option.forEach(onChangeFull, (function (fn) {
                  var content = getContent(editor);
                  fn({
                        content: content,
                        editor: editor
                      });
                }));
        }), [
        onChange,
        onChangeFull
      ]);
  var editor = Tiptap.ReactTiptap.useEditor(Tiptap.Editor.Config.make(Core__Option.getOr(props.initialContent, ""), onUpdate, props.onBlur, props.onFocus, {
            attributes: {
              class: (
                proseStyle === "sm" ? "prose-sm" : "prose"
              ) + " p-2 prose-zinc prose-ul:list-disc prose-ol:list-decimal grow prose-a:break-all prose-a:whitespace-pre-wrap prose-a:line-clamp-2 prose-a:overflow-hidden prose-a:inline focus-visible:outline-none"
            }
          }, props.placeholderText, toolbar === "withSingleHeadingLevel" ? [
              3,
              4
            ] : (
              toolbar === "default" ? [
                  1,
                  2,
                  3
                ] : []
            ), undefined));
  React.useEffect((function () {
          Core__Option.forEach(editorRef, (function (fn) {
                  fn(Core__Option.map(editor, (function (e) {
                              return {
                                      editor: e
                                    };
                            })));
                }));
        }), [
        editorRef,
        editor
      ]);
  var tmp;
  if (editor !== undefined) {
    var editor$1 = Caml_option.valFromOption(editor);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            toolbar === "withoutHeaders" || toolbar === "default" || toolbar === "withSingleHeadingLevel" ? JsxRuntime.jsx(RichTextEditorV5$Toolbar, {
                    editor: editor$1,
                    variant: toolbar
                  }) : null,
            JsxRuntime.jsx(Tiptap.ReactTiptap.EditorContent.make, {
                  editor: editor$1,
                  className: "grow flex"
                })
          ],
          className: TailwindMerge.twMerge([
                "border rounded flex flex-col",
                height === "short" ? "min-h-[10rem]" : "min-h-[14rem]",
                status !== undefined ? (
                    status === "ok" ? "border-tan-success" : "border-tan-error-500"
                  ) : "border-zinc-200"
              ])
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        ReactRender.fromOption(props.labelText, (function (labelText) {
                                return JsxRuntime.jsx(Form__Label.make, {
                                            labelText: labelText,
                                            optionalText: optionalText,
                                            htmlFor: id
                                          });
                              })),
                        ReactRender.fromOption(props.helpText, (function (helpText) {
                                return JsxRuntime.jsx(Form__HelpLabel.make, {
                                            children: helpText
                                          });
                              }))
                      ]
                    }),
                tmp
              ]
            });
}

var Icons;

var make$1 = RichTextEditorV5;

exports.Icons = Icons;
exports.Toolbar = Toolbar;
exports.getContent = getContent;
exports.make = make$1;
/* make Not a pure module */
